import React, { Component } from "react";
import { Platform, Linking } from "react-native";

import { NavigationActions } from "react-navigation";
import { AppURL } from "utils/config";

export function push(
	{ web: url, mobile: mobileUrl, params },
	props,
	bypass,
	https
) {
	if (Platform.OS !== "web") {
		props.navigation.navigate(mobileUrl, params);
		return;
	}

	if (bypass) {
		window.location.href = `https://${AppURL}${url}`;
		return;
	}

	if (https) {
		window.location.href = `https://${AppURL}${url}`;
		return;
	}

	props.history.push(url);
}

export function reset({ web: url, mobile: mobileUrl }, props, bypass) {
	if (Platform.OS === "web") {
		if (bypass) {
			window.location.href = `https://${AppURL}${url}`;
			return;
		} else {
			props.history.replace(url);
		}
	} else {
		const resetAction = NavigationActions.reset({
			index: 0,
			actions: [NavigationActions.navigate({ routeName: mobileUrl })],
		});
		props.navigation.dispatch(resetAction);
	}
}



// WEBPACK FOOTER //
// ./src/utils/navigation.js